import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { learnIndexCards } from "@/mocks/learn";
import { learnSubGuides } from "@/mocks/learnSubGuides";

export default function LearnIndex() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <section className="w-full border-b border-background-200 bg-background-100">
          <div className="mx-auto w-full max-w-content px-5 py-14 md:px-6 md:py-20">
            <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
              <span className="h-[1px] w-6 bg-primary-500" />
              Free Articles
            </p>
            <h1 className="mt-4 font-heading text-[28px] font-bold leading-[1.5] tracking-tight text-foreground-950 md:text-[38px]">
              無料で学ぶ
            </h1>
            <p className="mt-5 max-w-2xl text-[13.5px] leading-[2] text-foreground-700 md:text-[14.5px]">
              留学エージェントを使わず、費用を抑えてアメリカ留学を目指すための基本情報をまとめています。テキサス州のコミュニティカレッジへの留学と、そこから4年制大学への編入を中心に扱います。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-1.5 text-[11.5px] font-medium text-foreground-600">
              <i className="ri-shield-check-line text-[13px] text-primary-700" />
              すべて無料で読めます
            </p>
          </div>
        </section>

        <section className="w-full bg-background-50">
          <div className="mx-auto w-full max-w-content px-5 py-14 md:px-6 md:py-16">
            <div className="grid gap-5 md:grid-cols-2 md:gap-6 lg:grid-cols-3">
              {learnIndexCards.map((card, index) => (
                <Reveal key={card.slug} delay={(index % 3) * 70} className="h-full">
                  <Link
                    to={`/learn/${card.slug}`}
                    className="group flex h-full flex-col rounded-[10px] border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-[3px] hover:border-primary-300 hover:shadow-[0_20px_36px_-26px_rgba(23,37,35,0.45)] md:p-7"
                  >
                  <div className="flex items-center justify-between">
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-50 text-primary-700 transition-transform duration-300 group-hover:scale-105">
                      <i className={`${card.icon} text-[22px]`} />
                    </span>
                    <span className="font-heading text-[12px] font-bold tracking-[0.12em] text-background-400">
                      {card.number}
                    </span>
                  </div>
                  <h2 className="mt-5 font-heading text-[17px] font-bold leading-[1.6] text-foreground-950">
                    {card.title}
                  </h2>
                  <p className="mt-2.5 flex-1 text-[12.5px] leading-[1.9] text-foreground-600">
                    {card.description}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-[12px] font-semibold text-primary-700">
                    記事を読む
                    <i className="ri-arrow-right-line text-[13px] transition-transform duration-300 group-hover:translate-x-0.5" />
                  </span>
                  </Link>
                </Reveal>
              ))}

              <div className="flex flex-col rounded-[10px] border border-dashed border-background-300 bg-background-100 p-6 md:p-7">
                <p className="inline-flex w-fit items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-[11px] font-semibold text-foreground-600">
                  <i className="ri-lock-line text-[12px]" />
                  有料ガイド
                </p>
                <h2 className="mt-5 font-heading text-[17px] font-bold leading-[1.6] text-foreground-950">
                  もっと詳しく学ぶ
                </h2>
                <p className="mt-2.5 flex-1 text-[12.5px] leading-[1.9] text-foreground-600">
                  F-1ビザ、TSIA2対策、コミカレ留学準備の実践資料をPDFガイドとして準備しています。現在は制作中のため購入できません。
                </p>
                <Link
                  to="/guides"
                  className="mt-5 inline-flex items-center gap-1.5 text-[12px] font-semibold text-primary-700 transition-colors hover:text-primary-800"
                >
                  有料ガイドを見る
                  <i className="ri-arrow-right-line text-[13px]" />
                </Link>
              </div>
            </div>

            <div className="mt-12 rounded-[10px] border border-background-200 bg-background-100 px-5 py-6 md:px-6">
              <p className="flex flex-wrap items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-primary-700">
                <i className="ri-bookmark-line text-[13px]" />
                「コミカレの始め方」の詳細ページ
              </p>
              <p className="mt-2.5 max-w-2xl text-[12px] leading-[1.9] text-foreground-600">
                学校選びと英語力証明試験は、情報量が多いため別ページにまとめています。どちらも無料で読めます。
              </p>
              <div className="mt-4 grid gap-3.5 sm:grid-cols-2">
                {learnSubGuides.map((guide) => (
                  <Link
                    key={guide.slug}
                    to={`/learn/${guide.slug}`}
                    className="group flex items-start gap-3.5 rounded-[10px] border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-[3px] hover:border-primary-300 hover:shadow-[0_16px_32px_-24px_rgba(23,37,35,0.4)]"
                  >
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-50 text-primary-700">
                      <i className={`${guide.icon} text-[18px]`} />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex flex-wrap items-center gap-2">
                        <span className="font-heading text-[10.5px] font-bold tracking-[0.1em] text-background-400">
                          {guide.number}
                        </span>
                        <span className="rounded-full bg-primary-100 px-2 py-0.5 text-[10px] font-semibold text-primary-800">
                          無料
                        </span>
                      </span>
                      <span className="mt-1 block font-heading text-[13.5px] font-bold text-foreground-950">
                        {guide.title}
                      </span>
                      <span className="mt-1 block text-[11.5px] leading-[1.8] text-foreground-600">
                        {guide.description}
                      </span>
                    </span>
                  </Link>
                ))}
              </div>
            </div>

            <div className="mt-10 flex items-start gap-3 rounded-[10px] border border-background-200 bg-background-50 px-5 py-4">
              <i className="ri-error-warning-line mt-0.5 shrink-0 text-[16px] text-accent-600" />
              <p className="text-[12px] leading-[1.95] text-foreground-600">
                当サイトの記事は、制度の基本をわかりやすく整理したものです。必要書類・基準点・学費などは学校ごとに異なり、内容が変更される場合もあります。出願や申請の前に、必ず学校・政府機関の公式情報を確認してください。
              </p>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}